import { isImpersonatedSession } from "@/utils/impersonation";
import * as Sentry from "@sentry/react";

type AnnouncementEventProperties = {
  announcementId: number;
  announcementName: string;
  language: string;
};

function emit(event: string, properties: Record<string, unknown>) {
  // An infiltrating admin's clicks would otherwise count as the tenant's.
  if (isImpersonatedSession()) return;

  Sentry.addBreadcrumb({
    category: "announcement",
    message: event,
    level: "info",
    data: properties,
  });
}

function toEventProperties(properties: AnnouncementEventProperties) {
  return {
    announcement_id: properties.announcementId,
    announcement_name: properties.announcementName,
    language: properties.language,
  };
}

export function trackAnnouncementShown(
  properties: AnnouncementEventProperties,
): void {
  emit("announcement_shown", toEventProperties(properties));
}

export function trackAnnouncementCtaClicked(
  properties: AnnouncementEventProperties & { buttonId: string },
): void {
  emit("announcement_cta_clicked", {
    ...toEventProperties(properties),
    button_id: properties.buttonId,
  });
}

export function trackAnnouncementDismissed(
  properties: AnnouncementEventProperties,
): void {
  emit("announcement_dismissed", toEventProperties(properties));
}
